import { RouteRecordRaw } from 'vue-router';
import { requireAuth } from '@/common/router/navigationGuard';
import { VIEW_MODE } from '@/common/define/common.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { BASE_MENU_VALUE } from '@/common/components/organisms/baseMenu/baseMenu.define';
import { requireDomainTargetOrTutorial, requireInstances } from '@/common/router/authGuard';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_TIBERO = 'tibero_';

const tiberoMenu: RouteRecordRaw[] = [
  {
    path: '/tibero/',
    name: `${PREFIX_TIBERO}SQL Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'topNAnalysis',
        name: `${PREFIX_TIBERO}Top N Analysis`,
        component: () => import('@/database/views/topNAnalysis/tibero/TopNAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
      {
        path: 'searchSql',
        name: `${PREFIX_TIBERO}Search SQL`,
        component: () => import('@/database/views/searchSql/tibero/SearchSql.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_TIBERO_PA,
        [VIEW_MODE.MAXGAUGE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TIBERO_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
  {
    path: '/tibero/',
    name: `${PREFIX_TIBERO}Session Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'searchSession',
        name: `${PREFIX_TIBERO}Search Session`,
        component: () => import('@/database/views/searchSession/tibero/SearchSession.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_TIBERO_PA,
        [VIEW_MODE.MAXGAUGE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TIBERO_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
  {
    path: '/tibero/',
    name: `${PREFIX_TIBERO}Performance Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'trendAnalysis',
        name: `${PREFIX_TIBERO}Trend Analysis`,
        component: () => import('@/database/views/trendAnalysis/tibero/TrendAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
      {
        path: 'parameterHistory',
        name: `${PREFIX_TIBERO}Parameter History`,
        component: () => import('@/database/views/parameterHistory/tibero/ParameterHistory.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_TIBERO_PA,
        [VIEW_MODE.MAXGAUGE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TIBERO_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
  {
    path: '/tibero/',
    name: `${PREFIX_TIBERO}DataSpace Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'tablespace',
        name: `${PREFIX_TIBERO}Tablespace`,
        component: () => import('@/database/views/tablespace/tibero/Tablespace.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_TIBERO_PA,
        [VIEW_MODE.MAXGAUGE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TIBERO_PERFORMANCE_ANALYSIS,
      },
      invisibleViewMode: [VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.PA,
    },
  },
];

const subMenuMappingTibero = {
  instanceView: `${PREFIX_TIBERO}Real Time Monitoring`,
  sqlAnalysis: `${PREFIX_TIBERO}SQL Analysis`,
  sessionAnalysis: `${PREFIX_TIBERO}Session Analysis`,
  performanceAnalysis: `${PREFIX_TIBERO}Performance Analysis`,
  dataSpaceAnalysis: `${PREFIX_TIBERO}DataSpace Analysis`,
};

const getTiberoNaviMenu = (subMenu?: string) => {
  const filteredTiberoMenu = extractAccessibleRoutes(tiberoMenu);

  if (subMenu && subMenuMappingTibero[subMenu]) {
    return filteredTiberoMenu.filter((menu) => menu.name === subMenuMappingTibero[subMenu]);
  }

  return filteredTiberoMenu;
};

export { tiberoMenu, getTiberoNaviMenu, PREFIX_TIBERO };
